'use client'

import fukkuStyles from '@fukku/styles/classes.module.scss'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import replacePlaceholders from 'labels/lib/replacePlaceholders'
import styles from './ExtraColors.module.scss'

interface ExtraColorsProps {
	readonly dataTestId?: string
	readonly extraColors: number
}
export function ExtraColors({ dataTestId, extraColors }: ExtraColorsProps) {
	const { t } = useLabels()

	const accessibilityLabel = replacePlaceholders(
		t('accessibility.colorSelector.moreColors.button', extraColors),
		{ 1: extraColors }
	)
	return (
		<>
			<span
				aria-hidden='true'
				className={styles.extraColors}
				{...(dataTestId && { 'data-testid': `${dataTestId}.extraColors` })}
			>
				+{extraColors}
			</span>
			<span className={fukkuStyles.srOnly}>{accessibilityLabel}</span>
		</>
	)
}
